export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15092.ce390c38.jpg";